import React from "react";
import styled from "@emotion/styled";

import EmptyState from "@ats/src/components/shared/EmptyState";
import RemovableTag from "@ats/src/components/shared/RemovableTag";

export interface SourceOption {
  value: string;
  label: string;
}

interface Props {
  name?: string;
  options: SourceOption[];
  value: string[];
  onChange: (name: string, value: string[]) => void;
}

const SourceFilterSelect: React.FunctionComponent<Props> = ({
  name = "sources",
  options,
  value,
  onChange,
}) => {
  const selectedOptions = options.filter((option) => value.includes(option.value));

  const handleToggle = (id: string, isSelected: boolean) => {
    onChange(name, isSelected ? [...value, id] : value.filter((source) => source !== id));
  };

  return (
    <>
      {selectedOptions.length === 0 && (
        <Styled.EmptyState>
          <EmptyState message="No source filters have been added" />
        </Styled.EmptyState>
      )}

      {selectedOptions.length > 0 && (
        <Styled.SourceTagList>
          {selectedOptions.map((option) => (
            <RemovableTag
              key={option.value}
              removeLabel={`Remove ${option.label}`}
              onRemove={() => handleToggle(option.value, false)}
            >
              {option.label}
            </RemovableTag>
          ))}
        </Styled.SourceTagList>
      )}
    </>
  );
};

export default SourceFilterSelect;

/* Styled Components
======================================================= */
let Styled: any;
Styled = {};

Styled.EmptyState = styled.div`
  label: SourceFilterSelect_EmptyState;
`;

Styled.SourceTagList = styled.div`
  label: SourceFilterSelect_SourceTagList;
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
`;
